import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const headerVariants = cva("", {
  variants: {
    variant: {
      h1: "scroll-m-20 text-4xl font-inter font-extrabold tracking-tight lg:text-5xl",
      h2: "scroll-m-20 pb-2 text-3xl font-inter font-semibold tracking-tight first:mt-0",
      h3: "scroll-m-20 text-2xl font-inter font-semibold tracking-tight",
      h4: "scroll-m-20 text-xl font-inter font-semibold tracking-tight",
      h5: "scroll-m-20 text-lg font-inter font-semibold tracking-tight",
      h6: "scroll-m-20 text-base font-inter font-semibold tracking-tight",
    },
  },
  defaultVariants: {
    variant: "h4",
  },
});

export interface HeaderProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headerVariants> {
  asChild?: boolean;
}

export const Header = React.forwardRef<HTMLHeadingElement, HeaderProps>(
  ({ className, variant, ...props }, ref) => {
    const Comp = variant ?? "h4";
    return (
      <Comp
        className={cn(headerVariants({ variant, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);

// export function Header({
//   variant,
//   children,
// }: {
//   variant: Variant;
//   children: React.ReactNode;
// }) {
//   if (variant === "h1")
//     return (
//       <h1 className="scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl">
//         {children}
//       </h1>
//     );
//   else if (variant === "h2")
//     return (
//       <h2 className="scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight first:mt-0">
//         {children}
//       </h2>
//     );
//   else if (variant === "h3")
//     return (
//       <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
//         {children}
//       </h3>
//     );
//   else
//     return (
//       <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">
//         {children}
//       </h4>
//     );
// }
